'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _component = require('@loadable/component');

var _component2 = _interopRequireDefault(_component);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _BaseCombobox2 = require('../combobox/BaseCombobox');

var _BaseCombobox3 = _interopRequireDefault(_BaseCombobox2);

var _language = require('../language');

var _UtilApi = require('../utils/UtilApi');

var _IDAlert = require('./../alert/IDAlert');

var _IDAlert2 = _interopRequireDefault(_IDAlert);

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DualListBox = (0, _component2.default)(function () {
  return import("../lib/react-dual-listbox/src/js/DualListBox");
});

var IDDualList = function (_BaseCombobox) {
  (0, _inherits3.default)(IDDualList, _BaseCombobox);

  function IDDualList(props) {
    (0, _classCallCheck3.default)(this, IDDualList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IDDualList.__proto__ || (0, _getPrototypeOf2.default)(IDDualList)).call(this, props));

    _this.convertValue = function (value) {
      return value;
    };

    _this.handleChange = function (value) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly;

      if (disabled || readOnly) {
        return;
      }
      var _this$props2 = _this.props,
          maxLengthSelected = _this$props2.maxLengthSelected,
          alertLengthSelected = _this$props2.alertLengthSelected;

      if (maxLengthSelected >= value.length || !maxLengthSelected) {
        _this.setValue(value.length === 0 ? null : value);
      } else if (!alertLengthSelected) {
        _IDAlert2.default.Toast_info((0, _language.t)('Notification'), (0, _language.t)("Couldn't choose more") + ' ' + maxLengthSelected + '!', 0);
      } else {
        alertLengthSelected();
      }
    };

    _this.handleBlur = function () {
      _this.props.onBlur && _this.props.onBlur(_this.props.name, true);
    };

    _this.state = {
      options: (0, _UtilApi.getProxy)(props) ? [] : _this.convertData(props.options, true),
      value: props.value || props.defaultValue
    };
    _this.dataTestID = 'dual-list';
    return _this;
  }

  (0, _createClass3.default)(IDDualList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var proxy = (0, _UtilApi.getProxy)(this.props);
      if (proxy) {
        this.loadData(proxy, function (options) {
          _this2.setState({
            options: options
          });
        }, true);
      }
    }
  }, {
    key: 'setData',
    value: function setData(options, value) {
      var _this3 = this;

      this.setState({ options: options, value: value || null }, function () {
        _this3.props.onChange && _this3.props.onChange(value);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          placeholder = _props.placeholder,
          className = _props.className,
          style = _props.style,
          disabled = _props.disabled,
          iconAlign = _props.iconAlign,
          alignActions = _props.alignActions,
          visibleTitle = _props.visibleTitle,
          availableTitle = _props.availableTitle,
          selectedTitle = _props.selectedTitle,
          canFilter = _props.canFilter,
          preserveSelectOrder = _props.preserveSelectOrder;
      var _state = this.state,
          options = _state.options,
          value = _state.value;

      return _react2.default.createElement(
        'div',
        {
          'data-testid': this.getDataTestId(),
          className: (0, _classnames2.default)('input-dualListBox ' + className, { 'input-disabled': disabled }),
          style: style,
          onBlur: this.handleBlur
        },
        visibleTitle && _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)("title-dual-list-box", alignActions === "top" ? "align-top" : "") },
          _react2.default.createElement(
            'label',
            { className: 'align-left' },
            availableTitle
          ),
          _react2.default.createElement('label', { className: 'align-center' }),
          _react2.default.createElement(
            'label',
            { className: 'align-right' },
            selectedTitle
          )
        ),
        _react2.default.createElement(DualListBox, (0, _extends3.default)({}, this.props, {
          ref: function ref(c) {
            _this4.ref = c;
          },
          alignActions: alignActions,
          preserveSelectOrder: preserveSelectOrder,
          options: options,
          selected: _lodash2.default.map(value, function (item) {
            return item.toString();
          }) || [],
          canFilter: canFilter,
          filterPlaceholder: placeholder,
          onChange: this.handleChange,
          iconAlign: iconAlign,
          filterCallback: function filterCallback(option, filterInput) {
            if (filterInput === '') {
              return true;
            }
            return new RegExp(_this4.boDauTiengViet(filterInput), 'i').test(_this4.boDauTiengViet(option.label));
          }
        }))
      );
    }
  }]);
  return IDDualList;
}(_BaseCombobox3.default);

exports.default = IDDualList;


IDDualList.defaultProps = (0, _assign2.default)({}, _BaseCombobox3.default.defaultProps, {
  visibleTitle: false,
  placeholder: "Search...",
  canFilter: true,
  preserveSelectOrder: false,
  rootProperty: 'data.results'
});